<template>
  <v-layout wrap>
    <v-flex xs12 pa-3>
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>
            Unit In Media Type
          </v-toolbar-title>
          <v-spacer />
          <v-text-field append-icon="search" label="Search Media Type:" autofocus clearable v-model="search" color="white" box />
          <v-btn style="float: right;" color="success" dark @click="addAlia()">{{ $t('Button.Add_a_new_Media_Type') }}</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table :headers="headers" :items="UnitInMediaType" :pagination.sync="pagination" :search="search">
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.MediaType }}</td>
              <td style="width: 50%;">
                <v-select :items="['Concentration', 'Volume']" single-line v-model="props.item.UnitGroup"></v-select>
              </td>
            </template>
          </v-data-table>
          <v-btn style="float: left; bottom: 45px;" color="success" dark>{{ $t('Button.Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="addDialog" persistent max-width="800">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Add Media Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="addDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pl-3 pr-3>
              <v-select :items="['123']" label="Tenant"></v-select>
              <v-select :items="['Concentration', 'Volume']" label="Unit Group"></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="add" dark>{{ $t('Button.Save') }}</v-btn>
          <v-btn color="primary" @click="closeDialog()">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const analyte = createNamespacedHelpers('analyte')

  export default {
    data() {
      return {
        search: '',
        addDialog: false,
        headers: [{
          text: 'MediaType',
          value: 'MediaType',
          align: 'left',
        },
        {
          text: 'Unit Group',
          value: null,
          align: 'left',
        },
        ],
        pagination: {
          sortBy: 'AliaName',
          rowsPerPage: 10,
        },
        auditData: {},
        aliaData: {},
        UnitInMediaType: [{
          MediaType: 'Water',
          UnitGroup: 'Concentration',
        },
        {
          MediaType: 'Soil',
          UnitGroup: 'Volume',
        },
        ],
      }
    },
    mounted() {},
    computed: {
      ...analyte.mapGetters(['analyteAlias']),

    },
    watch: {},
    methods: {
      addAlia() {
        this.addDialog = true
      },
      closeDialog() {
        this.auditData = {}
        this.aliaData = {}
        this.auditDialog = false
        this.addDialog = false
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>